import gql from 'graphql-tag';

import { assetFieldsFragment } from './utils';

export default gql`
  ${assetFieldsFragment}
  query getAssets($status: String, $assetIds: [String]) {
    getAssets(status: $status, assetIds: $assetIds ) {
      ...assetFields
    }
  }
`;